import Vue from 'vue';
import Router from 'vue-router';
import Store from './store';
import NotFound from './views/NotFound.vue';
import Home from './views/Home.vue';
import ArtistProfile from './views/ArtistProfile.vue';
import RegistrationForm from './views/RegistrationForm.vue';
import Confirmation from './views/Confirmation.vue';
import Join from './views/Join.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/404',
      name: '404',
      component: NotFound,
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/join',
      name: 'join',
      component: Join,
    },
    {
      path: '/register',
      name: 'registration',
      component: RegistrationForm,
      beforeEnter: (to, from, next) => {
        if (from.name !== 'artist' || Object.keys(Store.getters.artist).length === 0 || Store.getters.completed) {
          Store.commit('completed', false);
          next('/');
        } else {
          Store.commit('fromRegistration', true);
          next();
        }
      },
    },
    {
      path: '/thanks',
      name: 'confirmation',
      component: Confirmation,
      beforeEnter: (to, from, next) => {
        let enter = true;

        if (from.name !== 'registration') {
          enter = false;
        }

        if (!Store.getters.completed) {
          enter = false;
        }

        if (!enter) {
          next('/');
        } else {
          Store.commit('completed', false);
          next();
        }
      },
    },
    {
      path: '/:handle',
      name: 'artist',
      component: ArtistProfile,
      beforeEnter: (to, from, next) => {
        Store.dispatch('fetchPlaces').then(() => {
          Store.dispatch('fetchArtist', to.params.handle)
            .then(() => {
              if (Object.keys(Store.getters.artist).length > 0 && Store.getters.artist.show) {
                next();
              } else {
                next('/404');
              }
            });
        });
      },
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);

  Store.dispatch('auth').then(() => {
    next();
  });

  if (from.name !== 'registration' || to.name !== 'artist') {
    Store.commit('fromRegistration', false);
  }
});

export default router;
